module.exports = __webpack_public_path__ + "img/moneygram.8eb7dec5.png";